import pure from "./higher-order/pure";
import LightBox from "./light-box";
import LightBoxBody from "./light-box-body";
import LightBoxFooter from "./light-box-footer";
import React from "react";

export default pure(function HelpBox({ children, onClose, title = "Help" }) {
  return (
    <LightBox onClose={onClose} title={title}>
      <LightBoxBody>
        {children}
      </LightBoxBody>

      <LightBoxFooter>
        <button className="btn btn-primary" onClick={onClose} type="button">
          Got it!
        </button>
      </LightBoxFooter>
    </LightBox>
  );
});
